module.exports = __webpack_public_path__ + "static/media/Success.f807055d.svg";